/* eslint-disable no-undef */
import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Layout from '../../components/global/layout';
import Feature from '../../components/global/feature';
import GeneralContent from '../../components/global/general-content';
import Events from '../../components/events/events';
import SEO from '../../components/global/seo';

const IndexPage = ({ data }) => {
  const interactiveData = data.interactive.nodes[0].unresolvedMicroEvents;
  const eventsHeader = interactiveData.eventsHeader;
  const events = interactiveData.events;
  const interestTitle = interactiveData.interestTitle;
  const interestContent = interactiveData.interestContent;
  /* eslint-disable operator-linebreak */
  const templateGlobals =
    data.interactive.nodes[0].unResolvedMicroTemplateGlobals;
  /* eslint-disable operator-linebreak */
  const relatedItems = templateGlobals.relatedContentItems;
  const hero = {
    type: templateGlobals.heroImageType,
    title: templateGlobals.heroImageTitle,
    subhead: templateGlobals.heroImageSubhead,
    heroImage: templateGlobals.heroImage,
    heroVideo: templateGlobals.loopingVideoMp4,
    heroVideoWebm: templateGlobals.loopingVideoWebm,
    applePodcastsUrl: templateGlobals.heroImageApplePodcastsUrl,
    spotifyUrl: templateGlobals.heroImageSpotifyUrl,
    generalCta: templateGlobals.heroImageGeneralCta,
  };
  const feature = {
    featureTypeOfFeature: templateGlobals.featureTypeOfFeature,
    featureImage: templateGlobals.featureImage,
    featureEmbed: templateGlobals.featureEmbed,
    featureDescription: templateGlobals.featureDescription,
  };
  const content = templateGlobals.generalContent;

  return (
    <Layout hero={hero} relatedItems={relatedItems}>
      <SEO
        title={`Un(re)solved | FRONTLINE | PBS | ${hero.title}`}
        description={(templateGlobals.metaDescription ? templateGlobals.metaDescription : '')}
      />
      {(feature.featureImage || feature.featureEmbed || feature.featureDescription) ?
        <Feature feature={feature} />
        : false}
      <GeneralContent content={content} />
      <Events eventsHeader={eventsHeader} events={events} />
      {(interestTitle ? (
        <div className="interest">
          <h3 className="interest__title">{interestTitle}</h3>
          <div className="interest__content">{parse(interestContent)}</div>
        </div>
      )
        : '')}
      {/* JSON.stringify(events) */}
    </Layout>
  );
};

export const query = graphql`
  {
    interactive: allWpInteractive(filter: { slug: { eq: "events" } }) {
      nodes {
        unresolvedMicroEvents {
          interestTitle
          interestContent
          eventsHeader
          events {
            eventDate
            eventFormat
            eventLink
            eventLocation
            eventName
            eventTime
            eventImage {
              localFile {
                childrenImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
        unResolvedMicroTemplateGlobals {
          heroImageType
          heroImageTitle
          heroImageSubhead
          loopingVideoMp4 {
              mediaItemUrl
          }
          loopingVideoWebm {
              mediaItemUrl
          }
          heroImage {
            localFile {
              childrenImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          heroImageApplePodcastsUrl
          heroImageSpotifyUrl
          heroImageGeneralCta {
            target
            title
            url
          }
          generalContent
          featureTypeOfFeature
          featureLink {
            target
            title
            url
          }
          featureImage {
            localFile {
              childrenImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          featureEmbed
          featureDescription
          metaDescription
          relatedContentItems {
            image {
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            link {
              target
              title
              url
            }
          }
        }
      }
    }
  }
`;

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default IndexPage;
